<div class="report-text-block-wrapper">
  <div class="title">
      <hyperkit-typography [variant]="variant">{{ title }}</hyperkit-typography>
  </div>
  <hyperkit-markdown [md]="value"></hyperkit-markdown>
</div>